/*
 * Copyright (c) 2019. Willker Gomes
 */
export default class Contact {

  constructor(props) {
    const {
      id,
      telefone1,
      telefone2,
      email,
      createdAt,
      updatedAt,
    } = props;

    this.id = id;
    this.telefone1 = telefone1;
    this.telefone2 = telefone2;
    this.email = email;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  /*
      "id": 2,
      "telefone1": "9999999999",
      "telefone2": "8888888888",
      "email": "teste001@email.com",
      "createdAt": "2019-08-19T19:37:14.568Z",
      "updatedAt": "2019-08-19T19:37:14.568Z"
  * */

}
